import React from 'react';
import { AppBar, Divider } from '@material-ui/core';
import './AppBar.scss';

/** @param {import('@material-ui/core').AppBarProps} param0 */
const CoreAppBar = ({ children, className, ...props }) => (
    <AppBar
        className={`core--app-bar ${className || ''}`}
        {...props}
        position='sticky'
        style={{ backgroundColor: 'white' }}
    >
        {children}
        <Divider />
    </AppBar>
);

export default CoreAppBar;